export const labelStyle = {
    width: '180px'
  };